import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '@contexts/LanguageContext';

export const CollectionHeader = ({
    title,
    description,
    modelName,
    customHeader,
    showViewAll
}) => {
    const { t } = useLanguage();

    if (!title) return null;

    return (
        <div className="collection-header">
            <div className="header-content">
                <h1>{title}</h1>
                {description && <p>{description}</p>}
            </div>
            <div className="header-actions">
                {customHeader}
                {showViewAll && modelName && (
                    <Link to={`/${modelName}`} className="view-all-button">
                        {t(`collection.viewAll${modelName.charAt(0).toUpperCase() + modelName.slice(1)}`)}
                    </Link>
                )}
            </div>
        </div>
    );
};

export default CollectionHeader;
